import { Providers } from "../../components/Providers";

export const ProvidersPage = () => {
  return (
    <div className="container__pages">
      <h2>Lista de proveedores</h2>
      <div className="container_form">
        <Providers />
      </div>
    </div>
  );
};
